import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import 'moment/locale/es';
moment.locale('en');

@Pipe({ name: 'dateFormat', pure: false })
export class DateFormatPipe implements PipeTransform {
    constructor(private translate: TranslateService) {}

    transform(value: Date | moment.Moment | string, dateFormat: string): any {
        if (!value) return '--';
        const locale = this.translate.currentLang || this.translate.defaultLang || 'en';
        return moment(value).local().locale(locale).format(dateFormat);
    }
}
